import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/content";
import { EASE, FadeIn, MaskedLine, Eyebrow } from "./Reveal";

export const Services = () => {
  const [active, setActive] = useState(0);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="mx-auto max-w-[1600px] px-6 pb-32 pt-7 sm:px-10 sm:pb-40 sm:pt-10 lg:px-16"
    >
      <div className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <FadeIn>
            <Eyebrow>Services</Eyebrow>
          </FadeIn>
          <h2 className="mt-8 font-serif font-light leading-[1.05] text-ink text-[clamp(2.4rem,5.5vw,4.8rem)]">
            <MaskedLine delay={0.1}>
              Every detail, <span className="italic text-olive">considered.</span>
            </MaskedLine>
          </h2>
        </div>
      </div>

      <div className="mt-20 grid gap-16 lg:grid-cols-12">
        <div className="flex flex-col lg:col-span-7">
          {SERVICES.map((s, i) => (
            <FadeIn key={s.slug} delay={i * 0.08} amount={0.2}>
              <button
                data-testid={`service-row-${s.slug}`}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className="group relative w-full border-t border-line/80 py-10 text-left last:border-b"
              >
                <span className="absolute inset-0 -z-0 bg-pale/0 transition-colors duration-700 group-hover:bg-pale/50" />
                <span className="relative z-10 flex items-baseline gap-6 px-2 sm:px-4">
                  <span className="font-serif text-sm italic text-olive/80">
                    {s.n}
                  </span>
                  <span className="font-serif text-3xl font-light text-ink transition-transform duration-700 ease-out group-hover:translate-x-3 sm:text-5xl">
                    {s.title}
                  </span>
                  <ArrowUpRight
                    size={22}
                    strokeWidth={1.25}
                    className="ml-auto shrink-0 self-center text-olive opacity-0 transition-all duration-500 group-hover:translate-x-1 group-hover:opacity-100"
                  />
                </span>
                <span className="relative z-10 mt-3 block max-w-md pl-14 pr-4 text-sm font-light text-ink/70 sm:pl-[4.25rem] sm:text-base">
                  {s.desc}
                </span>
                <span className="relative z-10 mt-6 block overflow-hidden px-2 sm:px-4 lg:hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    loading="lazy"
                    className="aspect-[16/10] w-full object-cover"
                  />
                </span>
              </button>
            </FadeIn>
          ))}
        </div>

        <div className="hidden lg:col-span-5 lg:block">
          <div className="sticky top-32 aspect-[3/4] overflow-hidden">
            <AnimatePresence mode="popLayout">
              <motion.img
                key={active}
                src={SERVICES[active].img}
                alt={SERVICES[active].title}
                initial={{ opacity: 0, scale: 1.07 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.9, ease: EASE }}
                className="absolute inset-0 h-full w-full object-cover"
              />
            </AnimatePresence>
            <div className="absolute bottom-0 left-0 bg-ivory/90 px-5 py-3 backdrop-blur-sm">
              <p className="text-[10px] font-medium uppercase tracking-[0.35em] text-ink">
                {SERVICES[active].n} — {SERVICES[active].title}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
